import { render, staticRenderFns } from "./NormalSearchNav477.vue?vue&type=template&id=31ed651e&scoped=true"
import script from "./NormalSearchNav477.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav477.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed651e",
  null
  
)

export default component.exports